import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TagDto, CategoryDto } from "../../../swagger/api.client.generated";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CategoriesAndTagsComponent } from "./categories-and-tags/categories-and-tags.component";

@Component({
  selector: "app-categories-and-tags-display",
  templateUrl: "./categories-and-tags-display.component.html",
  styleUrls: ["./categories-and-tags-display.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, CategoriesAndTagsComponent],
})
export class CategoriesAndTagsDisplayComponent {
  @Input() tags: TagDto[] | CategoryDto[];
  @Input() selectedTags: TagDto[] | CategoryDto[] = [];
  @Input() showAddCustomTag: boolean = false;
  @Input() classList: string = "";

  @Output() tagClicked = new EventEmitter<TagDto | CategoryDto | null>();

  onTagClicked(tag: TagDto | CategoryDto | null) {
    this.tagClicked.emit(tag);
  }

  isTagSelected(tag: TagDto | CategoryDto): boolean {
    return this.selectedTags.some((selected) => {
      // For custom tags (id === 0), we need to compare name and categoryId as well
      if (tag.id === 0 && selected.id === 0) {
        // Check if both are TagDto objects before accessing categoryId
        if ('categoryId' in tag && 'categoryId' in selected) {
          return selected.id === tag.id && 
                 selected.name === tag.name && 
                 selected.categoryId === tag.categoryId;
        }
        // Fallback to just id and name if categoryId is not available
        return selected.id === tag.id && selected.name === tag.name;
      }
      // For regular tags, just compare by id
      return selected.id === tag.id;
    });
  }
}
